var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvlBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 273,
    viewBox: "0 0 342 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42,
    filter: "url(#filter0_f_686_553)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.521 100.098C273.707 130.964 229.792 156.964 193.204 176.22C160.66 193.347 122.062 205.285 93.2197 190.252C57.8111 171.797 31.9159 136.933 52.9595 103.123C72.1781 72.2454 122.615 77.6243 163.686 77.0371C203.797 76.4636 255.575 70.0374 264.521 100.098Z",
    fill: "url(#paint0_linear_686_553)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_686_553",
    x: -30.1072,
    y: 0.575928,
    width: 371.362,
    height: 272.036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.75,
    result: "effect1_foregroundBlur_686_553"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_686_553",
    x1: 264.048,
    y1: 98.2875,
    x2: 51.0455,
    y2: 155.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08F684"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvlBg);
export default __webpack_public_path__ + "static/media/tvl-bg.4eaf11c03deb604f91b8404bc44cb025.svg";
export { ForwardRef as ReactComponent };